import React, { FC, useEffect, useRef } from 'react';
import styles from './MapLink.scss';
import { useSelector } from 'react-redux';
import { themeSelector } from 'app/store/selectors';
import globalThumbnail from './assets/global.png';
import trThumbnail from './assets/tr.png';
import ghThumbnail from './assets/gh.png';
import { emitSearchMaskMapEvent } from 'app/events/emitSearchMaskMapEvent';
import { useTranslations } from 'app/hooks/useTranslations';
import { Link } from '@flixbus/honeycomb-react';

export type MapLinkProps = {
  title: string;
  text: string;
  params?: string;
};

export const MapLink: FC<MapLinkProps> = ({ title, text, params = '' }) => {
  const { getMapLink } = useTranslations({ getMapLink: 'search_mask.explore_map.link_href' });
  const theme = useSelector(themeSelector);
  const href = `${getMapLink() || 'https://global.flixbus.com/bus-routes'}${params}`;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.parentElement?.role === 'option') {
      ref.current.parentElement.setAttribute('aria-hidden', 'true');
    }
  }, []);

  const getMapImage = () => {
    switch (theme) {
      case 'neptune':
        return ghThumbnail;
      case 'kamil':
        return trThumbnail;
      default:
        return globalThumbnail;
    }
  };

  return (
    <div ref={ref} className={styles.mapWrapper}>
      <Link
        tabIndex={-1}
        className={styles.mapLink}
        href={href}
        rel="noopener noreferrer"
        onClick={emitSearchMaskMapEvent}
      >
        <div className={styles.imageWrapper}>
          <img className={styles.image} src={getMapImage()} alt="map" />
        </div>

        <div>
          <p className={styles.title}>{title}</p>
          <span className={styles.fakeLink}>{text}</span>
        </div>
      </Link>
    </div>
  );
};
